var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_301_1",
    "data-name": "Component 301 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2358",
    "data-name": "Rectangle 2358",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    transform: "translate(10.475 9.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7400",
    "data-name": "Path 7400",
    d: "M481.6,70.569h-6.627a.69.69,0,0,0-.688.688V84.394a.69.69,0,0,0,.688.688h9.806a.69.69,0,0,0,.688-.688V74.436Z",
    transform: "translate(-474.283 -70.569)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7401",
    "data-name": "Path 7401",
    d: "M527.462,70.569v4.144h4.144",
    transform: "translate(-520.425 -70.569)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9973",
    "data-name": "Path 9973",
    d: "M1.09-2.266V-1.2H.354V-4.242H1.546a1.158,1.158,0,0,1,.826.269.951.951,0,0,1,.284.725,1,1,0,0,1-.127.506.88.88,0,0,1-.377.349,1.327,1.327,0,0,1-.607.127Zm.374-.59q.443,0,.443-.392t-.443-.4H1.09v.792Zm4.291.129a1.614,1.614,0,0,1-.192.794,1.342,1.342,0,0,1-.551.54,1.757,1.757,0,0,1-.846.194H3.018V-4.242H4.167a1.786,1.786,0,0,1,.848.189,1.321,1.321,0,0,1,.549.534A1.6,1.6,0,0,1,5.755-2.727ZM4.1-1.858a.93.93,0,0,0,.669-.228.845.845,0,0,0,.239-.641.845.845,0,0,0-.239-.641A.93.93,0,0,0,4.1-3.6H3.754v1.739ZM8.157-4.242v.585H6.909v.667h.964v.56H6.909V-1.2H6.173V-4.242Z",
    transform: "translate(1.453 11.255)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b073d11f9e9376ee66edd228908651cc.svg";
export { ForwardRef as ReactComponent };